import {DceComponent, DceHTMLElement} from "dce-engine";
import Dce from "dce-engine/lib/decorators/Dce";
import {Modal} from "app/lib/index";
import {DceAjax} from "dce-ajax";
import {CancelTokenSource} from "axios";
import {createDomElementFromString} from "app/lib/utils/createDomElementFromString";

interface LocalStorageSyncBlockProps {
    //klucz kóry obserwujemy
    key: string,

    //aktualna wartosc, jesli ulegnie zmiany robimy refresh
    value: string,

    //adres url do odswieżenia bloku przy zmianie wartości
    url: string
}

@Dce("localStorageSyncBlock")
export default class LocalStorageSyncBlock extends DceComponent<LocalStorageSyncBlockProps> {

    private content: HTMLElement;

    private requestCancelTokenSource: CancelTokenSource;

    private storageEventListener: (e:StorageEvent) => void;

    constructor(elem: DceHTMLElement, props: LocalStorageSyncBlockProps) {
        super(elem, props);

        console.log("LOCAL STORAGE SYNC");

        this.storageEventListener = e => {

            let newValue = localStorage.getItem(this.props.key);

            if(newValue == this.props.value){
                return;
            }

            if(null != this.requestCancelTokenSource){
                console.log("CANCEL PREV REQUEST");
                this.requestCancelTokenSource.cancel("Next change");
                //this.requestCancelTokenSource = null;
            }

            console.log("UPDATE VALUE TO: " + newValue);

            this.requestCancelTokenSource = DceAjax.cancelTokenSource();

            DceAjax.getInstance().get(this.props.url, {
                cancelToken: this.requestCancelTokenSource.token
            }).then(response => {
                this.requestCancelTokenSource = null;
                if(response.isValid() && response.hasResponse()){
                    this.elem.replaceWith(
                        createDomElementFromString(response.response)
                    );
                }
            });

        };

        window.addEventListener('storage', this.storageEventListener);

    }


    onRemove() {
        console.log("UNBIIIIND STORAGE EVENT!!!!")
        window.removeEventListener('storage', this.storageEventListener);
    }
}